<div class="dialog" style="display: flex; flex-direction: column;">
    <h1 mat-dialog-title style="width: 100%;">Réinitialisation du mot de passe</h1>
    <div mat-dialog-content style="display: flex; flex-direction: column;">
        <p style="width: 100%;">Veuillez saisir votre adresse email d'inscription</p>
        <mat-form-field style="width: 100%;">
            <mat-label>Email du compte</mat-label>
            <input matInput type="email" [(ngModel)]="data.email">
        </mat-form-field>
    </div>
    <div mat-dialog-actions align="center">
        <button mat-raised-button (click)="onNoClick()" color="warn">Annuler</button>
        <button mat-raised-button [mat-dialog-close]="{ email: data.email }" [disabled]="!regexp.test(data.email)" color="primary" cdkFocusInitial>Valider</button>
    </div>
</div>
